<!-- =========================================================================================
  File Name: companyView.vue
  Description: All Projects list
  ----------------------------------------------------------------------------------------
  Item Name: KOZO Admin - VueJS Dashboard 
  Author:  
  Author URL:  
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <div class="vx-col w-full">
        <router-link to="/apps/projects">
          <feather-icon icon="ArrowLeftCircleIcon" svgClasses="h-8 w-8" />
        </router-link>
      </div>
      <!-- COMPANY FORMS -->
      <div class="vx-col w-full mb-base" v-if="UserRole != 'Admin Manager'">
        <company-form v-if="checkPermission(['company','POST'])"></company-form>
      </div>

      <vs-tabs v-if="checkPermission(['company','GET'])">
        <vs-tab label="Company List" icon-pack="feather" icon="icon-box">
          <div class="tab-text">
            <!-- COMPANY LIST -->
            <div>
              <company-list></company-list>
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Archive List" icon-pack="feather" icon="icon-box">
          <div>
            <company-list listType="archive"></company-list>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
  </div>
</template>

<script>
import CompanyForm from "@/views/apps/company/companyForm.vue";
import CompanyList from "@/views/apps/company/companyList.vue";

export default {
  data() {
    return {
      isActive: false,
      analyticsData: "",
      isImp: false,
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      show: false,
      items: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      nextNum: 10,
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot"
      ]
    };
  },
  computed: {
    UserRole() {
      return localStorage.getItem("UserRole") || null;
    }
  },
  methods: {
    myFilter: function() {
      this.isActive = !this.isActive;
    }
  },
  components: {
    CompanyForm,
    CompanyList
  }
};
</script>

<style lang="scss">
</style>
